import { Component, DestroyRef, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BreadcrumbModel } from '../model/breadcrumb.model';
import { NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FuseConfigService } from '@fuse/services/config';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { AppConfig } from 'app/core/config/app.config';
import { BreadcrumbService } from '../service/breadcrumb.service';

@Component({
    selector: 'app-breadcrumb',
    imports: [MatIconModule, NgClass, TranslateModule],
    templateUrl: './breadcrumb.component.html',
    styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
    @Input() breadCrumbConfig: BreadcrumbModel[] = []
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    showBreadcrumb: boolean = false;
    subscription: Subscription
    private readonly destroyRef= inject(DestroyRef);

    constructor(private _fuseConfigService: FuseConfigService, private breadcrumbService: BreadcrumbService) {
    }

    ngOnInit() {
        this._fuseConfigService.config$.pipe(takeUntil(this._unsubscribeAll),
            takeUntilDestroyed(this.destroyRef)).subscribe((config: AppConfig) => {
            if (config.layout === 'enterprise' || config.layout === 'modern') {
                this.showBreadcrumb = true;
            }
        });

        this.subscription = this.breadcrumbService.breadcrumbs$.subscribe((breadcrumbs) => {
            this.breadCrumbConfig = breadcrumbs;
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
